<template>
  <div class="home">
    <!-- fixed bg -->
    <div class="fixed-bg" />
    <!-- banner -->
    <div class="banner" :class="$t('msg.hello') === 'hello' ? 'ban-second' : 'ban-first'">
      <div class="layer">
        <p class="tit">{{ $t("home.banner_tit") }}</p>
        <div class="line animate__animated animate__lightSpeedInLeft animate__delay-800ms" />
        <div class="btn-list" :style="{ bottom: $t('msg.hello') === 'hello' ? '12%' : '15%' }">
          <CoButton @click.native="$router.push({ path: 'applynow' })" arrow>{{ $t("btn_list.want_apply") }}
          </CoButton>
          <CoButton color="green" arrow>
            <router-link :to="{ path: 'supportingpartners' }">{{
              $t("btn_list.want_dona")
            }}</router-link>
          </CoButton>
        </div>
      </div>
    </div>
    <!-- 计划目的 -->
    <div class="plan-bg">
      <div class="plan">
        <div class="tit">{{ $t("home.plan_tit") }}</div>
        <p class="desc" v-html="$t('home.plan_con')"></p>
        <CoButton color="green">
          <router-link :to="{ path: 'overview' }">{{
            $t("btn_list.learn_more")
          }}</router-link>
        </CoButton>
      </div>
    </div>
    <!-- 申请资格 -->
    <div class="apply-bg">
      <div class="apply">
        <p class="tit">{{ $t("home.apply_require") }}</p>
        <p class="desc" v-html="$t('home.apply_con')"></p>
        <!-- <p class="tips">{{ $t("home.economic") }}</p> -->
        <!-- <div class="conditions">
          <div class="con">
            <span class="num">1</span>
            <span>{{ $t("home.condition_1") }}</span>
          </div>
          <div class="con">
            <span class="num">2</span>
            <span>{{ $t("home.condition_2") }}</span>
          </div>
          <div class="con">
            <span class="num">3</span>
            <span>{{ $t("home.condition_3") }}</span>
          </div>
          <div class="con">
            <span class="num">4</span>
            <span>{{ $t("home.condition_4") }}</span>
          </div>
        </div> -->
        <CoButton color="green">
          <router-link :to="{ path: 'overview?#eligibility' }">{{
            $t("btn_list.show_more")
          }}</router-link>
        </CoButton>
      </div>
    </div>
    <!-- 计划内容 -->
    <div class="plan-con">
      <div class="con-bg">
        <div class="con">
          <p class="tit">{{ $t("home.plan_con_tit") }}</p>
          <p class="txt">{{ $t("home.plan_con_txt") }}</p>
          <p v-show="$t('msg.hello') !== 'hello'" class="con-tips">
            ^常規課程指每星期或每月有恆常訓練的課程
          </p>
          <CoButton color="green">
            <router-link :to="{ path: 'overview?#overview' }">{{
              $t("btn_list.browse_more")
            }}</router-link>
          </CoButton>
        </div>
      </div>
    </div>
    <!-- 申请时序 -->
    <div class="animated apply-time animate__animated animate__lightSpeedInLeft animate__delay-800ms" :style="{
        background:
          '#f3f3f3 url(/home-bg/aplly_time' + bgNum + '.png) center/100%',
      }">
      <!--<p class="tit">{{ $t("scholarship.time_tit") }}</p>
      <p class="tips">{{ $t("scholarship.timeLines_Detail[0].phase") }}</p>-->
      <!-- :style="{background:'#f3f3f3 url(../assets/img/home/aplly_time'+bgNum+'.png)no-repeat 100%'}" --
      <p class="tit">{{ $t("scholarship.time_tit") }}</p>
      <p class="tips">{{ $t("scholarship.timeLines_Detail[0].phase") }}</p>
      <!- <p class="tips">{{ $t("scholarship.test_span") }}</p> --
      <div class="time-line">
        <div class="line-item" v-for="(item, index) in homeData.time_line" :key="index">
          <div class="time" :class="selectTimeItem === index ? 'active-time' : ''" @click="changeTimeLine(index)">
            <span class="time-tit">{{ item.title }}</span>
            <div class="circle">
              <div class="line" :class="selectTimeItem === index ? 'active-line' : ''" v-show="index < homeData.time_line.length - 1" />
            </div>
          </div>
          <div class="time-story" v-show="selectTimeItem === index">
            <p class="con">
              {{ item.content }}
            </p>
          </div>
        </div>
      </div>-->
      <div class='timeline'>
        <div class='legend'>
          <div class='phase1'>
            <div class='icon1'></div>
            <div class='text'>{{ $t('home.phase1') }}</div>
          </div>
          <div class='phase2'>
            <div class='icon2'></div>
            <div class='text'>{{ $t('home.phase2') }}</div>
          </div>
        </div>
        <!--<div class='main'>
          <div class='role'>
            <div>{{ $t('home.role_top') }}</div>
            <div>{{ $t('home.role_bottom') }}</div>
          </div>
          <div class='container'>
            <div class='inner'>
              <div class='item' v-for='(item, i) in timeline' :key='i'>
                <div :class='item.top ? "content-top" : "content-bottom"'>
                  <div>
                    {{ item.text }}
                  </div>
                </div>
                <div :class='item.phase1 ? "line-phase1" : "line-phase2"'></div>
              </div>
            </div>
          </div>
        </div>-->
      </div>

      <div class='timeline-outer-container' @click='enlargeTimeline'>
        <div class='timeline-container' :style='{zoom: enlarge ? "1" : "0.58"}'>
          <div class='title-container'>
            <div class='content'>
              {{ $t("scholarship.time_tit") }}
              <div class='baseline'></div>
            </div>
          </div>
          <div :class='["content-container", !item.green ? "content-container-blue" : ""]' v-for='(item, i) in timeline' :key='i'>
            <div class='line'></div>
            <div :class='["pointer", item.left ? "left-pointer" : "right-pointer"]'></div>
            <div :class='["stage-container", !item.left ? "stage-container-right" : ""]'>
              <div class="count">
                {{ i+1 }}
              </div>
              <div class='stage-title'>
                {{ $t(item.title) }}
              </div>
              <div class='stage-text'>
                <span>{{$t(item.text)}}</span>
                <div class='baseline'></div>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <div class='submit-deadline'>
        <div class='text'>
          {{ $t('home.submit_deadline_text') }}
        </div>
        <div class='container'>
          <div class="item"></div>
          <div class="item">{{ $t('home.submit_deadline0') }}</div>
          <div class="item">{{ $t('home.release_month0') }}</div>  
          <div class="item">1</div>
          <div class="item">{{ $t('home.submit_deadline1') }}</div>
          <div class="item">{{ $t('home.release_month1') }}</div>  
          <div class="item">2</div>
          <div class="item">{{ $t('home.submit_deadline2') }}</div>
          <div class="item">{{ $t('home.release_month2') }}</div> 
          <div class="item">3</div>
          <div class="item">{{ $t('home.submit_deadline3') }}</div>
          <div class="item">{{ $t('home.release_month3') }}</div> 
        </div>
      </div>
    </div>
    <!-- 舊生故事 -->
    <div class="student-story-bg">
      <p class="tit">{{ $t("home.student_story_tit") }}</p>
      <div class="student-story">
        <div class="story-tank">
          <div class="pic">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide class="swiper-slide" v-for="(item, index) in homeData.student_story" :key="index">
                <img :src="item.imgPath" />
              </swiper-slide>
              <div @click="changeStudent('prev')" class="swiper-button-prev" slot="button-prev"></div>
              <div @click="changeStudent('next')" class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
          <div class="con">
            <div class="info">
              <p class="con-tit">{{ currentStudentStory.name }}</p>
              <p class="desc-short">
                {{ currentStudentStory.tit }}
              </p>
              <div class="border" />
              <p class="desc" v-html="currentStudentStory.con"></p>
              <CoButton :href="currentStudentStory.toLink">{{
                $t("btn_list.his_story")
              }}</CoButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 學生展示 -->
    <div class="student-show">
      <div class="student-show-item">
        <img src="../assets/img/home/dum1.png" />
      </div>
      <div class="student-show-item">
        <img src="../assets/img/home/dum2.png" />
      </div>
      <div class="student-show-item">
        <img src="../assets/img/home/dum3.png" />
      </div>
      <div class="student-show-item">
        <img src="../assets/img/home/dum4.png" />
      </div>
    </div>
    <!-- 口號 -->
    <CommonSlogan />
  </div>
</template>

<script>
// @ is an alias to /src
import { swiper, swiperSlide } from "vue-awesome-swiper";
require("swiper/dist/css/swiper.css");
import CommonSlogan from "../components/CommonSlogan.vue";
import CoButton from "../components/co-button/co-button.vue";
export default {
  name: "Home",
  data () {
    return {
      timeline: [
        {
          text: this.$t('home.timeline[0]'),
          title: this.$t('home.timeline_title[0]'),
          left: true,
          green: false
        },
        {
          text: this.$t('home.timeline[1]'),
          title: this.$t('home.timeline_title[1]'),
          left: false,
          green: false
        },
        {
          text: this.$t('home.timeline[2]'),
          title: this.$t('home.timeline_title[2]'),
          left: true,
          green: false
        },
        {
          text: this.$t('home.timeline[3]'),
          title: this.$t('home.timeline_title[3]'),
          left: false,
          green: false
        },
        {
          text: this.$t('home.timeline[4]'),
          title: this.$t('home.timeline_title[4]'),
          left: true,
          green: false
        },
        {
          text: this.$t('home.timeline[5]'),
          title: this.$t('home.timeline_title[5]'),
          left: false,
          green: false
        },
        {
          text: this.$t('home.timeline[6]'),
          title: this.$t('home.timeline_title[6]'),
          left: true,
          green: true
        },
        {
          text: this.$t('home.timeline[7]'),
          title: this.$t('home.timeline_title[7]'),
          left: false,
          green: true
        },
        {
          text: this.$t('home.timeline[8]'),
          title: this.$t('home.timeline_title[8]'),
          left: true,
          green: true
        },
      ],
      realIndex: 0,
      // timeLines: this.$t("scholarship.time_line"),
      selectTimeItem: 0,
      // studentStory: this.$t("home.student_story"),
      // applyConIsShow: false,
      // 当前查看的学生下标
      currentStudentIndex: 0,
      // 当前查看的学生信息
      currentStudentStory: [],
      // 轮播图配置
      swiperOption: {
        activeIndex: 0,
        //循环
        loop: true,
        //设定初始化时slide的索引
        initialSlide: 0,
        //滑动速度
        speed: 0,
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      bgNum: 1,
      enlarge: false
      // locale: window.localStorage.getItem("locale"),
    };
  },
  components: {
    CommonSlogan,
    CoButton,
    swiper,
    swiperSlide,
  },
  created () {
    // 初始化显示学生信息
    this.currentStudentStory = this.homeData.student_story[0];
    this.timer();
    this.enlargeTimeline()
  },
  methods: {
    enlargeTimeline() {
      if(window.screen.width>960) {
        this.enlarge = true
      }
    },
    // 切换显示学生信息
    changeStudent (type) {
      this.$nextTick(function () {
        // 判断按的是上一张还是下一张
        if (type !== "next") {
          var num = this.$refs.mySwiper.swiper.activeIndex;
          // 处理上一张swiper的index异常
          num = num === 0 ? 1 : num === 2 ? 0 : 2;
          this.currentStudentStory = this.homeData.student_story[num];
        } else {
          //正常下一张%3得到下标
          this.currentStudentStory = this.homeData.student_story[
            this.$refs.mySwiper.swiper.activeIndex % 3
          ];
        }
      });
    },
    changeTimeLine (index) {
      this.selectTimeItem = index;
    },
    timer () {
      return setInterval(() => {
        const oldNum = this.bgNum;
        this.bgNum = oldNum === 1 ? 2 : 1;
      }, 500);
    },
  },
  computed: {
    homeData: function () {
      return this.$t("home");
    },
  },
  destroyed () {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.animated {
  height: 1380px;
}
.timeline-outer-container {
  cursor: pointer;
  height: 700px;
  padding: 30px 0;
  overflow-y: auto;
  background-color: white;
  border-radius: 15px;
  border: 1px solid #dad8d8;
}
.timeline-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 1195px;
  .title-container {
    border-radius: 8px;
    background-color: #f8d95d;
    width: 250px;
    height: 70px;
    border: none;
    padding: 8px;
    box-sizing: border-box;
    .content {
      position: relative;
      font-size: 20px;
      box-sizing: border-box;
      color: white;
      border: 1px solid #f7e8ab;
      height: 100%;
      text-align: center;
      padding-top: 8px;
      .baseline {
        position: absolute;
        bottom: 8px;
        width: 80%;
        height: 1px;
        left: 10%;
        background-color: #f7e8ab;
      }
    }
  }
  .content-container {
    position: relative;
    width: 70%;
    height: 125px;
    .line {
      position: absolute;
      z-index: 10;
      width: 3px;
      height: 100%;
      left: 50%;
      transform: translateX(-1.5px);
      background-color: #85c358;
    }
    .line::before {
      content: '';
      position: absolute;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      box-sizing: border-box;
      top: 50%;
      background-color: white;
      transform: translate(-11px, -12.5px);
      border: 3px solid #85c358;
      z-index: 1;
    }
    .pointer {
      position: absolute;
      width: 15%;
      height: 1px;
      top: 50%;
      background-color: #85c358;
    }
    .left-pointer {
      right: 50%;
    }
    .right-pointer {
      left: calc(50% + 12.5px);
    }
    .pointer::before {
      content: '';
      position: absolute;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      top: 50%;
      background-color: #85c358;
      transform: translate(0, -2.5px);
      z-index: 1;
    }
    .right-pointer::before {
      right: 0;
    }
    .stage-container {
      position: relative;
      height: 100%;
      width: 50%;
      .count {
        position: absolute;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
        vertical-align: middle;
        color: white;
        background-color: #85c358;
        z-index: 5;
      }
      .stage-title {
        position: absolute;
        left: 50px;
        padding: 5px;
        background-color: #85c358;
        z-index: 5;
        color: white;
        font-size: 15px;
      }
      .stage-text {
        position: absolute;
        display: table;
        width: 70%;
        height: 80%;
        border: 1px solid #85c358;
        border-radius: 5px;
        box-sizing: border-box;
        top: 15px;
        left: 15px;
        padding: 0 15px;
        color: #85c358;
        text-align: center;
        span {
          display: table-cell;
          vertical-align: middle;
        }
        .baseline {
          position: absolute;
          bottom: 10px;
          width: 80%;
          height: 1px;
          left: 10%;
          background-color: #85c358;
        }
      }
    }
    .stage-container-right {
      margin-left: 50%;
      .count {
        left: calc(30% - 15px);
      }
      .stage-title {
        left: calc(30% + 35px);
      }
      .stage-text {
        left: 30%;
      }
    }
  }
  .content-container-blue {
    .line {
      background-color: #2191d0;
    }
    .line::before {
      border: 3px solid #2191d0;
    }
    .pointer {
      background-color: #2191d0;
    }
    .pointer::before {
      background-color: #2191d0;
    }
    .stage-container {
      .count {
        background-color: #2191d0;
      }
      .stage-title {
        background-color: #2191d0;
      }
      .stage-text {
        border: 1px solid #2191d0;
        color: #2191d0;
        .baseline {
          background-color: #2191d0;
        }
      }
    }
  }
}
.submit-deadline {
  margin-top: 30px;
  box-sizing: border-box;
  padding: 30px 0;
  width: 100%;
  height: 410px !important;
  background-color: white;
  border-radius: 15px;
  border: 1px solid #dad8d8;
  .text {
    text-align: center;
    padding: 0 30px;
  }
  .container {
    display: grid;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    width: 70%;
    grid-template-columns: 2fr 5fr 5fr;
    .item {
      border: 1px solid rgba(0, 0, 0, 0.8);
      padding: 20px;
      font-size: 17px !important;
      text-align: center;
    }
  }
}
.timeline {
  box-sizing: border-box;
  padding: 30px 70px;
  width: 100%;
  height: 105px;
  margin-bottom: 10px;
  background-color: white;
  border-radius: 15px;
  border: 1px solid #dad8d8;
  display: flex;
  flex-direction: column;
  .legend {
    display: flex;
    justify-content: space-around;
    height: 100px;
    margin: 0 auto;
    .phase1 {
      margin-right: 70px;
    }
    .phase2 {
      margin-left: 70px;
    }
    .phase1, .phase2 {
      display: flex;
      .text {
        margin-left: 20px;
        margin-top: 8px;
      }
    }
    .icon1 {
      width: 25px;
      height: 25px;
      background-color: white;
      border-radius: 50%;
      border: 7px solid #2191d0;
    }
    .icon2 {
      width: 25px;
      height: 25px;
      background-color: white;
      border-radius: 50%;
      border: 7px solid #85c358;
    }
  }
  /*.main {
    display: flex;
    justify-content: space-around;
    height: 100%;
    .role {
      display: flex;
      flex: 1 1 0;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
    }
    .container {
      flex: 5 1 0;
      overflow: auto;
      .inner {
        width: 1800px;
        display: flex;
        height: 100%;
        .item {
          width: 220px;
          height: 100%;
          position: relative;
          .line-phase1, .line-phase2 {
            position: absolute;
            height: 8px;
            width: 100%;
            top: 50%;
          }
          .line-phase2 {
            background-color: #85c358;
          }
          .line-phase1 {
            background-color: #2191d0;
          }
          .line-phase1::before, .line-phase2::before {
            content: '';
            position: absolute;
            width: 25px;
            height: 25px;
            top: 0;
            left: 42.5%;
            margin-top: -16px;
            background-color: white;
            border-radius: 50%;
            z-index: 1;
          }
          .line-phase1::before {
            border: 7px solid #2191d0;
          }
          .line-phase2::before {
            border: 7px solid #85c358;
          }
          .content-top, .content-bottom {
            position: absolute;
            left: 0; 
            right: 0; 
            margin-left: auto; 
            margin-right: auto; 
            width: 180px;
            height: 35%;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            div {
              width: 100%;
              text-align: center;
              overflow-wrap: break-word; 
            }
          }
          .content-bottom {
            bottom: 0;
          }
        }
      }
    }
  }*/
}
.home {
  width: 100%;
  overflow: hidden;
}
.fixed-bg {
  height: 100vh;
  max-width: 1200px;
  width: 100%;
  background: url("../assets/img/home/fixed-bg.png") repeat-y center / 400%;
  position: fixed;
  z-index: -1;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
}
.banner {
  max-width: 1200px;
  height: 43.5vw;
  margin: 0 auto;
  z-index: 1;
  position: relative;
  background-size: 100% 100%;
  .layer {
    width: 100%;
    height: 100%;
    .tit {
      width: 100%;
      color: #fff;
      font-weight: 600;
      text-shadow: 2px 2px 7px #000;
      text-align: center;
      letter-spacing: 6px;
      margin: 0;
      position: absolute;
      left: 50%;
      top: 20%;
      transform: translateX(-50%);
      font-size: 34px;
    }
    .line {
      height: 4px;
      width: 40%;
      background: #85c358;
      position: absolute;
      left: 30%;
      top: 35%;
    }
    .btn-list {
      color: #fff;
      width: 65%;
      text-align: center;
      position: absolute;
      left: 50%;
      bottom: 15%;
      transform: translateX(-50%);
      .green-btn {
        margin-left: 3vw;
      }
    }
  }
}
.ban-first {
  background: url("../assets/img/home/ban1.jpg") no-repeat center/100%;
  background-position-y: 0%;
}
.ban-second {
  background: url("../assets/img/home/scholarship2.jpg") no-repeat center/100%;
  background-position-y: 0%;
}
.plan-bg {
  max-width: 1200px;
  margin: 0 auto;
  // width: 100%;
  color: #fff;
  text-align: center;
  font-weight: 600;
  .plan {
    margin: 0 auto;
    padding: 2vw;
    z-index: 1;
    position: relative;
    .tit {
      height: 4vw;
      font-size: 34px;
    }
    .desc {
      width: 80%;
      margin: 0 auto 2vw;
      line-height: 37px;
      font-size: 16px;
    }
  }
}
.apply-bg {
  max-width: 1200px;
  margin: 0 auto;
  z-index: 1;
  position: relative;
  background: #fff;
  .apply {
    text-align: center;
    font-weight: 600;
    padding: 2vw;
    .tit {
      height: 4vw;
      color: #2191d0;
      font-size: 34px;
    }
    .desc {
      width: 70%;
      margin: 0 auto 2vw;
      line-height: 37px;
      font-size: 16px;
    }
    .tips {
      line-height: 5.4vw;
      color: #2191d0;
    }
    .conditions {
      display: flex;
      width: 55%;
      margin: 0 auto;
      justify-content: space-between;
      flex-wrap: wrap;
      .con {
        display: flex;
        align-items: center;
        width: 40%;
        font-weight: normal;
        font-size: 1.2vw;
        margin-bottom: 15px;
        .num {
          font-size: 4.8vw;
          color: #2191d0;
          font-weight: 200;
          transform: translateY(-10px);
          padding-right: 5px;
        }
      }
    }
  }
}
.plan-con {
  max-width: 1200px;
  margin: 0 auto;
  background: url("../assets/img/home/plan.png") no-repeat center / 100%;
  z-index: 1;
  position: relative;
  .con-bg {
    // height: 38vw;
    width: 100%;
    background: linear-gradient(
      to left,
      rgba(#3a82a7, 0.1),
      rgba(#3a82a7, 0.7)
    );
    .con {
      color: #fff;
      margin-left: 10%;
      padding: 4% 0 10%;
      .tit {
        font-size: 34px;
        line-height: 82px;
        font-weight: 600;
      }
      .txt {
        width: 25vw;
        line-height: 37px;
        font-size: 16px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 7;
        overflow: hidden;
      }
      .con-tips {
        font-size: 10px;
        margin-top: 10px;
      }
      .more-btn {
        margin-top: 3vw;
      }
    }
  }
}
.apply-time {
  max-width: 1200px;
  margin: 0 auto;
  // background: #f3f3f3 url("../assets/img/home/aplly_time1.png") no-repeat center /
  //   100%;
  // padding: 2vw 2vw 18vw;
  padding: 2vw;
  box-sizing: border-box;
  z-index: 1;
  position: relative;
  .tit {
    font-size: 34px;
    color: #2191d0;
    font-weight: 600;
    text-align: center;
    line-height: 6vw;
  }
  .tips {
    text-align: center;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .time-line {
    margin: 0 auto;
    border-radius: 15px;
    border: 1px solid #dad8d8;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 0 120px;
    margin-top: 1.8vw;
    .line-item {
      display: flex;
      justify-content: center;
      position: relative;
      width: 15%;
      justify-content: center;
      .time-tit {
        text-align: center;
        display: inline-block;
        height: 7vw;
        font-size: 16px;
        display: flex;
        flex-direction: column-reverse;
        width: 85%;
      }
      .shortTit {
        width: 70px;
      }
      .time {
        display: flex;
        flex-direction: column;
        align-items: center;
        .time-tit {
          text-align: center;
          height: 7vw;
          display: flex;
          flex-direction: column-reverse;
        }
        .circle {
          width: 1vw;
          height: 1vw;
          border-radius: 50%;
          border: 0.3vw solid #85c358;
          background: #fff;
          margin: 1vw 0;
          position: relative;
          z-index: 1;
          cursor: pointer;
          &:hover {
            width: 1.5vw;
            height: 1.5vw;
            // border: 0.5vw solid #2191d0;
            .line {
              transform: translateY(0.6vw) translateX(2vw);
            }
          }
          .line {
            width: 150px;
            height: 0.5vw;
            background: #dfe0e2;
            transform: translateY(0.4vw) translateX(1.4vw);
          }
          .active-line {
            background: #85c358;
          }
        }
      }
      .active-time {
        color: #85c358;
        .circle {
          border: 0.5vw solid #85c358 !important;
          width: 1.5vw;
          height: 1.5vw;
          .line {
            transform: translateY(0.6vw) translateX(1.8vw);
          }
        }
      }
      .time-story {
        width: 12vw;
        position: absolute;
        background: #85c358;
        color: #fff;
        top: 12vw;
        left: 65px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        border-radius: 3px;
        &::before {
          content: "";
          width: 0px;
          height: 0px;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: 10px solid #85c358;
          position: absolute;
          top: -10px;
          left: 10px;
        }
        .con {
          font-size: 12px;
          padding: 15px;
          color: #fff;
        }
      }
      // &:nth-child(4) .circle,
      // &:nth-child(5) .circle,
      // &:nth-child(6) .circle {
      //   border-color: #2191d0 !important;
      //   .active-line {
      //     background: #2191d0;
      //   }
      // }
      // &:nth-child(4) .active-time,
      // &:nth-child(5) .active-time,
      // &:nth-child(6) .active-time {
      //   color: #2191d0 !important;
      // }
      // &:nth-child(7) .circle {
      //   border-color: #df8244 !important;
      // }
      // &:nth-child(7) .active-time {
      //   color: #df8244 !important;
      // }
    }
  }
}
.student-story-bg {
  width: 100%;
  background: #85c358;
  .tit {
    font-size: 34px;
    font-weight: 600;
    color: #2191d0;
    text-align: center;
    height: 10vw;
    line-height: 12vw;
    background: white;
  }
  .student-story {
    max-width: 1200px;
    margin: 0 auto;
    z-index: 1;
    position: relative;
    background: #fff;
    border-bottom: solid 1px white;
    .story-tank {
      display: flex;
      width: 100%;
      position: relative;
      max-height: 680px;
      .pic {
        // overflow: hidden;
        width: 38%;
        & img {
          width: 108%;
        }
        .swiper-container {
          position: unset;
          .swiper-button-prev {
            background-image: url("../assets/img/home/l.png");
            left: 39%;
          }
          .swiper-button-next {
            background-image: url("../assets/img/home/r.png");
            right: 1%;
          }
        }
      }
      .con {
        width: 62%;
        background: #85c358;
        color: #fff;
        display: flex;
        padding: 20px 5%;
        box-sizing: border-box;
        .info {
          .con-tit {
            font-size: 25px;
            font-weight: 600;
          }
          .desc-short {
            font-size: 14px;
            font-weight: 600;
            line-height: 0;
            margin: 16px 0;
          }
          .desc {
            font-size: 16px;
            line-height: 20px;
            margin: 20px 0;
          }
          .border {
            width: 20%;
            height: 3px;
            background: #2191d0;
            margin-bottom: 0.5vw;
          }
        }
        .more-btn {
          width: 110px;
          line-height: 40px;
        }
      }
    }
  }
}
.student-show {
  max-width: 1200px;
  margin: 0 auto;
  height: 31vw;
  padding: 0 11.8vw;
  background: white;
  display: flex;
  padding-top: 5vw;
  // width: 76.4vw;
  .student-show-item {
    display: inline-block;
    width: 25%;
    &:nth-child(even) {
      padding-top: 10vw;
    }
    & > img {
      width: 100%;
      // height: 100%;
      transition: all ease-in-out 1s;
      // cursor: pointer;
      &:hover {
        transform: scale(1.2);
        z-index: 999;
      }
    }
  }
}

@media screen and (max-width: 960px) {
.animated {
  height: 1150px;
}
.timeline-outer-container {
  height: 400px;
}
.timeline-container {
  .content-container {
    height: 135px;
    width: 90%;
    .stage-container {
      .stage-title {
        font-size: 12px;
        left: 40px;
      }
      .stage-text {
        top: 17px;
        font-size: 13px;
      }
    }
    .stage-container-right {
      .stage-title {
        left: calc(40% - 5px);
      }
    }
  }
}
.submit-deadline {
  height: 470px !important;
  .container {
    .item {
      font-size: 12px !important;
    }
  }
}
.timeline {
  height: 150px;
  font-size: 12px;
  .legend {
    display: flex;
    flex-direction: column;
    .phase1 {
      margin-right: 0;
    }
    .phase2 {
      margin-left: 0;
      margin-top: 10px;
    }
    .icon1 {
      width: 20px;
      height: 20px;
      background-color: white;
      border-radius: 50%;
      border: 4px solid #2191d0;
    }
    .icon2 {
      width: 20px;
      height: 20px;
      background-color: white;
      border-radius: 50%;
      border: 4px solid #85c358;
    }
  }
}

  .banner {
    .layer {
      .line {
        top: 45%;
      }
    }
  }

  .apply-time {
    .time-line {
      width: 100%;
      height: 100px;
      margin-top: 4vw;
      padding: 70px 0;
    }
  }
}

@media screen and (max-width: 768px) {
  .fixed-bg {
    background: url("../assets/img/home/fixed-bg.png") repeat-y center / 700%;
  }
  .banner {
    padding: 2vw;
    .layer {
      .tit {
        font-size: 20px;
        top: 13%;
        letter-spacing: 0;
      }
      .btn-list {
        width: 100%;
        & > a {
          margin-left: 3vw;
        }
      }
    }
  }
  .plan-bg {
    .plan {
      .tit {
        font-size: 20px;
        height: auto;
      }
      .desc {
        line-height: 18px;
        font-size: 12px;
        width: 80%;
      }
    }
  }
  .apply-bg {
    .apply {
      .tit {
        height: auto;
        font-size: 20px;
      }
      .desc {
        width: 80%;
        line-height: 18px;
        font-size: 12px;
      }
      .conditions {
        width: 85%;
        .con {
          width: 45%;
          font-size: 2vw;
        }
      }
    }
  }
  .plan-con {
    .con-bg {
      height: auto;
      .con {
        color: #fff;
        margin-left: 5vw;
        padding: 2vw;
        .tit {
          font-size: 20px;
          font-weight: 600;
          line-height: 35px;
        }
        .txt {
          width: 50vw;
          line-height: 18px;
          font-size: 12px;
        }
        .con-tips {
          margin: 0;
        }
        .more-btn {
          margin-top: 2vw;
        }
      }
    }
  }
  .apply-time {
    padding: 0 4vw 8vw 2vw;
    .tit {
      font-size: 20px;
      line-height: 12vw;
    }
    .time-line {
      width: 100%;
      height: 100px;
      margin-top: 4vw;
      padding: 50px 0 180px;
      .line-item {
        .time {
          // color: #2191d0;
          width: 10vw;
          font-size: 10px;
          .time-tit {
            display: flex;
            height: 70px;
            font-size: 8px;
            line-height: unset;
            flex-direction: column-reverse;
            width: 40px;
          }
          .circle {
            width: 1.8vw;
            height: 1.8vw;
            margin: 10px 0;
            &:hover {
              width: 2vw;
              height: 2vw;
              // border: 0.5vw solid #2191d0;
              .line {
                transform: translateY(1vw) translateX(2.7vw);
              }
            }
            .line {
              width: 12vw;
              height: 0.5vw;
              background: #dfe0e2;
              transform: translateY(0.9vw) translateX(2vw);
            }
            .active-line {
              background: #85c358;
            }
          }
        }
        .active-time {
          .circle {
            width: 2vw;
            height: 2vw;
            .line {
              transform: translateY(1vw) translateX(2.7vw);
            }
          }
        }
        .time-story {
          width: 85px;
          top: 30vw;
          left: 0vw;
          padding: 0 10px;
          &::before {
              left:15px
            }
          .con {
            font-size: 8px;
            padding: 5px 2px;
          }
          .con-tit {
            border-bottom: 1px solid #fff;
            padding-bottom: 5px;
            line-height: 5vw;
            text-align: center;
            font-size: 3.5vw;
          }
        }
        // &:nth-child(4) .circle,
        // &:nth-child(5) .circle,
        // &:nth-child(6) .circle {
        //   .active-line {
        //     background: #2191d0;
        //   }
        // }
        // &:nth-child(7) .active-time {
        //   color: #df8244 !important;
        // }
      }
    }
  }
  .student-story-bg {
    .tit {
      font-size: 20px;
    }
    .student-story {
      .story-tank {
        // max-height: 228px;
        .pic {
          width: 50%;
          img {
            width: 100%;
            // height: 100%;
          }
          .swiper-container {
            .swiper-button-prev {
              left: 52%;
              width: 7%;
              height: 10%;
            }
            .swiper-button-next {
              right: 0%;
              width: 8%;
              height: 10%;
            }
          }
        }
        .con {
          width: 50%;
          padding: 2% 10%;
          .rotation-btn {
            & > img {
              width: 50%;
            }
          }
          .info {
            .con-tit {
              font-size: 20px;
            }
            .desc-short {
              font-size: 12px;
              line-height: 18px;
              margin: 0;
            }
            .desc {
              font-size: 12px;
              line-height: 18px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 4;
              overflow: hidden;
              margin: 0;
            }
            .border {
              width: 45%;
            }
            .more-btn {
              margin-top: 3.4vw;
              width: unset;
              line-height: 7.3vw;
            }
          }
        }
      }
    }
  }
  .student-show {
    height: 38vw;
    padding: 8vw 0 0 0;
  }
}
</style>
